function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import { createPopper } from '@popperjs/core';
export var usePopper = function usePopper(props) {
  var enabled = props.enabled,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottom-end' : _props$placement,
      _props$preventOverflo = props.preventOverflow,
      preventOverflow = _props$preventOverflo === void 0 ? true : _props$preventOverflo,
      offsetProp = props.offset,
      _props$gutter = props.gutter,
      gutter = _props$gutter === void 0 ? 8 : _props$gutter,
      _props$flip = props.flip,
      flip = _props$flip === void 0 ? true : _props$flip,
      _props$fixed = props.fixed,
      fixed = _props$fixed === void 0 ? false : _props$fixed,
      _props$modifiers = props.modifiers,
      modifiers = _props$modifiers === void 0 ? [] : _props$modifiers;
  var reference = React.useRef(null);
  var popper = React.useRef(null);
  var instanceRef = React.useRef(null);
  var cleanup = React.useRef(function () {});
  var customModifiers = React.useMemo(function () {
    return [{
      name: 'offset',
      enabled: !!offsetProp,
      options: {
        offset: offsetProp !== null && offsetProp !== void 0 ? offsetProp : [0, gutter]
      }
    }, {
      name: 'preventOverflow',
      enabled: !!preventOverflow,
      phase: 'main'
    }, {
      name: 'flip',
      enabled: !!flip,
      options: {
        padding: 8
      }
    }];
  }, [flip, gutter, offsetProp, preventOverflow]);
  var setupPopper = React.useCallback(function () {
    var _cleanup$current, _instanceRef$current;

    if (!reference.current || !popper.current) return;
    (_cleanup$current = cleanup.current) === null || _cleanup$current === void 0 ? void 0 : _cleanup$current.call(cleanup);
    instanceRef.current = createPopper(reference.current, popper.current, {
      enabled: enabled,
      placement: placement,
      modifiers: customModifiers.concat(modifiers),
      strategy: fixed ? 'fixed' : 'absolute'
    }); // force update one-time to fix any positioning issues

    instanceRef.current.forceUpdate();
    cleanup.current = (_instanceRef$current = instanceRef.current) === null || _instanceRef$current === void 0 ? void 0 : _instanceRef$current.destroy;
  }, [enabled, placement, customModifiers, modifiers, fixed]);
  React.useEffect(function () {
    return function () {
      var _instanceRef$current2;

      (_instanceRef$current2 = instanceRef.current) === null || _instanceRef$current2 === void 0 ? void 0 : _instanceRef$current2.destroy();
      instanceRef.current = null;
    };
  }, []);
  return React.useMemo(function () {
    return {
      referenceRef: function referenceRef(node) {
        reference.current = node;
        setupPopper();
      },
      popperRef: function popperRef(node) {
        popper.current = node;
        setupPopper();
      },
      getPopperProps: function getPopperProps() {
        var _instanceRef$current3, _instanceRef$current4, _instanceRef$current5, _instanceRef$current6;

        return _objectSpread(_objectSpread({}, (_instanceRef$current3 = instanceRef.current) === null || _instanceRef$current3 === void 0 ? void 0 : (_instanceRef$current4 = _instanceRef$current3.state.attributes) === null || _instanceRef$current4 === void 0 ? void 0 : _instanceRef$current4.popper), {}, {
          style: _objectSpread({}, (_instanceRef$current5 = instanceRef.current) === null || _instanceRef$current5 === void 0 ? void 0 : (_instanceRef$current6 = _instanceRef$current5.state.styles) === null || _instanceRef$current6 === void 0 ? void 0 : _instanceRef$current6.popper)
        });
      }
    };
  }, [setupPopper]);
};